import { lazy } from "react";

// React.lazy that retries a failed chunk download (slow VE links / brief CDN hiccup)
// before surfacing ChunkLoadError to the error boundary.
export function lazyRetry(factory, retries = 2) {
  return lazy(() => new Promise((resolve, reject) => {
    const attempt = (left) => factory().then(resolve).catch((err) => {
      if (left <= 0) return reject(err);
      setTimeout(() => attempt(left - 1), 1500 * (retries - left + 1));
    });
    attempt(retries);
  }));
}
